var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-tabs',{attrs:{"tabs":_vm.tabs,"active-index":_vm.activeTabIndex}})
}
var staticRenderFns = []

export { render, staticRenderFns }